import React, { Component } from 'react';
import './HouseTypeFilter.css';
import CheckboxFilter from './CheckboxFilter';
import MenuType from '../enums/MenuType';
import Option from '../choices/Option';
import SubMenuHeader from './SubMenuHeader';
import ClickedOffManager from '../ui_core/ClickedOffManager';
import Once from '../core/Once';
export default class HouseTypeFilter extends Component {
	constructor(props){
		super(props)
		const {onSelectedOptionsChange} = props;
		this._checkboxFilter=React.createRef();
		this._subMenuHeader = React.createRef();
		this._element = React.createRef();
		this.load = this.load.bind(this);
		this.show = this.show.bind(this);
		this.hide= this.hide.bind(this);
		this.setFromWhatAreYouLookingForViewModel= this.setFromWhatAreYouLookingForViewModel.bind(this);
		this._setHouseTypeViewModelsToShow= this._setHouseTypeViewModelsToShow.bind(this);
		this.filterPlots = this.filterPlots.bind(this);
		this.clear = this.clear.bind(this);
		this._updateOptions= this._updateOptions.bind(this);
		
		this._handleSelectedOptionsChanged=this._handleSelectedOptionsChanged.bind(this);
		
		this._iMenuManager  = null;
		this.state = {options:[], visible:false, siteJson:null};
		this._clickedOffManager = new ClickedOffManager({elementRef:this._element, hide:this.hide});
		this._selectedOptionsChangedOnce = new Once(onSelectedOptionsChange);
	}
	show(){
		this.setState({visible:true});
		this._clickedOffManager.register();
		this._iMenuManager.showMe(this);
	}
	hide(){
		this._clickedOffManager.dispose();
		this.setState({visible:false});
		this._iMenuManager.close();
	}
	filterPlots(plotsArray){
		const houseTypeViewModelsToShow = this._checkboxFilter.current.getCheckedValues();
		const houseTypesToShow= [];
		houseTypeViewModelsToShow.forEach(houseTypeViewModelToShow=>{
			houseTypeViewModelToShow.houseTypesWithSameName.forEach(houseType=>houseTypesToShow.push(houseType));
		});
		if(houseTypesToShow.length<1)return plotsArray;
		return plotsArray.filter(plot=>houseTypesToShow.indexOf(plot.houseType)>=0);
	}
	clear(){
		this._houseTypesViewModel?.entries.forEach(houseTypeViewModel=>houseTypeViewModel.selected = false);
		this._checkboxFilter.current.clear();
	}
	setFromWhatAreYouLookingForViewModel(whatAreYouLookingForViewModel){
		const houseTypeViewModels = whatAreYouLookingForViewModel.houseTypes;
		if(!houseTypeViewModels)return;
		this._setHouseTypeViewModelsToShow(houseTypeViewModels);
	}
	setIMenuManager(value){
		this._iMenuManager = value;
		this._subMenuHeader.current.setIMenuManager(value);
	}
	get menuType(){
		return MenuType.HOUSE_TYPE_FILTER;
	}
	get isApplied(){
		return this._checkboxFilter.current.isApplied;
	}
	load(houseTypesViewModel, siteJson){
		this.setState({siteJson});
		this._houseTypesViewModel = houseTypesViewModel;
		this._updateOptions();
	}
	_handleSelectedOptionsChanged(o){
		const houseTypesToShow= [];
		const houseTypeViewModelsToShow = this._checkboxFilter.current.getCheckedValues();
		this._setHouseTypeViewModelsToShow(houseTypeViewModelsToShow);
	}
	_setHouseTypeViewModelsToShow(houseTypeViewModelsToShow){
		houseTypeViewModelsToShow.forEach(houseTypeViewModelToShow=>{
			houseTypeViewModelToShow.selected = true;
		});
		this._houseTypesViewModel.entries
			.filter(houseTypeViewModel=>houseTypeViewModelsToShow.indexOf(houseTypeViewModel)<0)
			.forEach(houseTypeViewModel=>houseTypeViewModel.selected = false);
	}
	_updateOptions(){
		const options = this._houseTypesViewModel.entries.map((houseTypeViewModel)=>{
			const option = new Option({text:(<div>{houseTypeViewModel.name}&nbsp;<img src={houseTypeViewModel.imageAbsolutePath}></img></div>),
				value:houseTypeViewModel});
			houseTypeViewModel.addEventListener('selectedchanged', ()=>{
				const checkboxOption = this._checkboxFilter.current.getCheckboxOptions()
				.map(checkboxOption=>checkboxOption.ref.current)
				.filter(checkboxOption=>{
					const value= checkboxOption.value;
					return value===houseTypeViewModel;
				})[0];
				checkboxOption.isChecked = houseTypeViewModel.selected;
				this._selectedOptionsChangedOnce.trigger();
			});
			return option;
		});
		this._checkboxFilter.current.setOptions(options);
	}
	render() {
		let className ="house-type-filter  menu";
		if(this.state.visible)
			className+=" visible";
		return (<div className={className} ref={this._element}>
				<SubMenuHeader ref={this._subMenuHeader} title={this.state.siteJson?.allUnitsHaveMultiplePlots?"Apartment Type":"House type"}></SubMenuHeader>
				<CheckboxFilter ref={this._checkboxFilter} onSelectionChange={this._handleSelectedOptionsChanged}></CheckboxFilter></div>)
	}
}
